export function getBotReply(message: string) {
    const lowerMsg = message.toLowerCase();

    if (lowerMsg.includes("start") && lowerMsg.includes("mbsyep")) {
        return `The 2025 MBSYEP program starts on Monday, June 23, 2025, and ends on Friday, August 1, 2025. The program runs for 6 weeks and includes 29 paid workdays. Please note that Friday, July 4 is a holiday and will not be paid.`;
    }

    if (
        lowerMsg.includes("how much") &&
        (lowerMsg.includes("pay") || lowerMsg.includes("paid"))
    ) {
        return `Great question! Your hourly pay depends on your age:\n\nAges 14–15: $6.25/hour (up to 20 hours/week)\n\nAges 16–21: $9.00/hour (up to 25 hours/week)\n\nAges 22–24: $17.50/hour (up to 30 hours/week)\nKeep in mind that hours may be reduced during the week of July 4.`;
    }

    if (lowerMsg.includes("timesheet") || lowerMsg.includes("pay history")) {
        return `You can view your timesheets and pay history by logging into your CYPMS Youth Portal and navigating to “My Payroll”. There, you'll find your submitted work hours, payment status, and downloadable pay stubs. You can also print copies for your records!`;
    }

    if (["hi", "hello", "hey"].some((greet) => lowerMsg.includes(greet))) {
        return "Hi there! How can I assist you with the MBSYEP 2025 program?";
    }

    return "I'm sorry, I don't have an answer for that right now. Try rephrasing or ask another question.";
}